module.exports = __webpack_public_path__ + "img/1.29598810.jpg";